/**
 * Where the user entered a job detail from, so that leaving it can put them back.
 *
 * Carried as a query param (see `urlFunctions.createJobDetail`) rather than router state, so it
 * survives a reload and a copied link. Mirrors the `CarrierReferrer` pattern, but lives in its own
 * module so `useNavigation` does not have to import a component to get at the enum.
 */
export enum JobReferrer {
  /** The jobs centre — also the default, since a job is always findable there. */
  JOBS = 'jobs',
  EXPEDITIONS = 'expeditions',
}
